import { __awaiter, __generator } from '../../node_modules/tslib/tslib.es6.js';
import { ApolloError } from '@apollo/client/core';
import { searchProducts, UNAUTHENTICATED_SEARCH_PRODUCTS } from '../../api/graphQl/product.js';
import { useState, useCallback, useEffect } from 'react';

var useRecommendedProducts = function (props) {
    var _a = useState(false), loading = _a[0], setLoading = _a[1];
    var _b = useState(null), error = _b[0], setError = _b[1];
    var _c = useState(undefined), recommendedProducts = _c[0], setRecommendedProducts = _c[1];
    var product = props.product, isUserSignedIn = props.isUserSignedIn;
    var fetchRecommendedProducts = useCallback(function (product) { return __awaiter(void 0, void 0, void 0, function () {
        var restrictToBrand, response, error_1;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    setLoading(true);
                    setError(null);
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, , 4]);
                    restrictToBrand = !product.isInternalCompany;
                    return [4 /*yield*/, props.apolloClient.query({
                            query: isUserSignedIn ? searchProducts : UNAUTHENTICATED_SEARCH_PRODUCTS,
                            variables: {
                                page: { start: 0, size: 10 },
                                subCategoryIds: product.subCategoryId != null ? [+product.subCategoryId] : [],
                                brandIds: restrictToBrand && product.brandId != null ? [+product.brandId] : [],
                                sort: [{ fieldName: 'searchScore', direction: 'desc' }],
                                titleExclude: product.stacklineSku ? [product.stacklineSku] : [],
                                computeFacets: false,
                            },
                        })];
                case 2:
                    response = _c.sent();
                    if (response.loading) {
                        setLoading(true);
                        return [2 /*return*/];
                    }
                    if (response.error) {
                        setError(response.error.message);
                        return [2 /*return*/];
                    }
                    if ('SearchProducts' in response.data) {
                        setRecommendedProducts((_a = response.data.SearchProducts) === null || _a === void 0 ? void 0 : _a.products);
                    }
                    else if ('UnauthenticatedSearchProducts' in response.data) {
                        setRecommendedProducts((_b = response.data.UnauthenticatedSearchProducts) === null || _b === void 0 ? void 0 : _b.products);
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _c.sent();
                    if (error_1 instanceof Error || error_1 instanceof ApolloError) {
                        setError(error_1.message);
                    }
                    else if (typeof error_1 === 'string') {
                        setError(error_1);
                    }
                    else {
                        console.error(error_1);
                        setError('Failed to fetch recommended products');
                    }
                    return [3 /*break*/, 4];
                case 4:
                    setLoading(false);
                    return [2 /*return*/];
            }
        });
    }); }, [props.apolloClient, product, isUserSignedIn]);
    useEffect(function () {
        fetchRecommendedProducts(product);
    }, [fetchRecommendedProducts, product]);
    return {
        loading: loading,
        error: error,
        recommendedProducts: recommendedProducts,
    };
};

export { useRecommendedProducts };
//# sourceMappingURL=useRecommendedProducts.js.map
